export default __webpack_public_path__ + "static/media/iphone-app.7d754442.png";